function menuDesktop() {


    /* Toggle contact DIV */
    const contact_link = document.querySelector('#menu-menu-secondaire-gauche > li');
    const contact_div = document.querySelector('.site-header .contact__infos');

    if (contact_link && contact_div) {
        contact_link.addEventListener('click', function (e) {
            e.preventDefault();
            contact_div.classList.toggle('--visible')
        });
    }


    /* Toggle histoire DIV */
    const histoire_link = document.querySelector('#menu-menu-secondaire-gauche > .menu-item-has-children');
    const histoire_div = document.querySelector('#menu-menu-secondaire-gauche li > .sub-menu');

    if (histoire_link && histoire_div) {
        histoire_link.addEventListener('click', function (e) {

            if (e.target.getAttribute('href') === '#') {
                e.preventDefault();
            }

            histoire_div.classList.toggle('--visible');
        });
    

	    const children = histoire_div.children;
	    for (let i = 0; i < children.length; i++) {
	        // console.log(children[i]);
	        children[i].addEventListener('click', function (e) {
	            if (this.classList.contains('menu-item-has-children')) {
	                histoire_div.classList.toggle('--visible');
	                const submenu = this.querySelector(".sub-menu");
	                submenu.classList.toggle('display');
	            }
	        })
	
	    }
	}

    // Mobile
    jQuery('.site-header .contact__infos').clone().appendTo('#menu-menu-secondaire-gauche-1 > li');
    jQuery('#menu-menu-secondaire-gauche-1 > li .contact__infos a').removeAttr('target');
    const contact_link_mobile = document.querySelector('#menu-menu-secondaire-gauche-1 > li');
    const contact_div_mobile = document.querySelector('#menu-menu-secondaire-gauche-1 .contact__infos');

    if (contact_link_mobile && contact_div_mobile) {
        contact_link_mobile.addEventListener('click', function (e) {
            var $target = jQuery(e.target);
            if (!$target.hasClass('btn')) {
                e.preventDefault();
            }
            contact_div_mobile.classList.toggle('--visible')
        });
    }

    const histoire_link_mobile = document.querySelector('#menu-menu-secondaire-gauche-1 > .menu-item-has-children');
    const histoire_div_mobile = document.querySelector('#menu-menu-secondaire-gauche-1 li > .sub-menu');

    if (histoire_link_mobile && histoire_div_mobile) {
        histoire_link_mobile.addEventListener('click', function (e) {
            if (!histoire_div_mobile.classList.contains('--visible')) {
                e.preventDefault();
            }

            if (e.target.getAttribute('href') === '#') {
                e.preventDefault();
            }

            histoire_div_mobile.classList.toggle('--visible');
        });
    }

    /* Hide main logo on scroll */
    const logo = document.querySelectorAll('.logo');
    const header = document.querySelector('.site-header');
    const content = document.querySelector('.site-content');

    document.addEventListener('scroll', function () {
        if (window.pageYOffset > header.offsetHeight / 2) {
            header.classList.add('fixed');
            content.classList.add('--menu_open');
            // logo[0].classList.remove('hide');
            logo[0].closest('.secondary-menu').classList.add('--menu_is_scrolled');
            logo[1].classList.add('hide');
        } else {
            header.classList.remove('fixed');
            content.classList.remove('--menu_open');
            // logo[0].classList.add('hide');
            logo[0].closest('.secondary-menu').classList.remove('--menu_is_scrolled');
            logo[1].classList.remove('hide');
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        if (window.pageYOffset > header.offsetHeight / 2) {
            header.classList.add('fixed');
            content.classList.add('--menu_open');
            // logo[0].classList.remove('hide');
            logo[0].closest('.secondary-menu').classList.add('--menu_is_scrolled');
            logo[1].classList.add('hide');
        } else {
            header.classList.remove('fixed');
            content.classList.remove('--menu_open');
            // logo[0].classList.add('hide');
            logo[0].closest('.secondary-menu').classList.remove('--menu_is_scrolled');
            logo[1].classList.remove('hide');
        }
    });
}

const handleClick = (e) => {
    e.preventDefault();
    const {parentNode} = e.currentTarget;
    const linksContainer = document.querySelector('.handheld-navigation');
    const allLinks = linksContainer.querySelectorAll('li.menu-item');
    const otherMenu = document.querySelector('.menu-other');

    if (e.currentTarget.classList.contains('active')) { // == Retour d'un cran

        // On cache tous les liens
        allLinks.forEach(link => link.classList.add('hidden'));

        // On affiche le lien actuel
        parentNode.classList.remove('hidden');

        // On marque le lien actuel comme non-actif
        e.currentTarget.classList.remove('active');

        // On affiche les liens du cran du dessus
        let parent = parentNode.parentNode.parentNode;
        const link = parent.querySelector(':scope > a.hidden');
        if (link) {
            // On retire l'ancien lien actif
            link.classList.add('active');
            link.classList.remove('hidden');
        }

        if (parent.classList.contains('hidden')) {
            while (parent.classList.contains('hidden')) {
                // On affiche le parent du dessus
                parent.classList.remove('hidden');

                // On passe au parent du dessus
                parent = parent.parentNode.parentNode;
            }
        }

        const links = parentNode.parentNode.querySelectorAll(':scope > .menu-item');
        const subMenu = parentNode.querySelector('.sub-menu');
        subMenu.classList.remove('not-hidden');
        links.forEach(link => link.classList.remove('hidden'));

    } else { // == Avance d'un cran

        // On cache tous les liens
        allLinks.forEach(link => link.classList.add('hidden'));

        // On affiche le lien actuel
        parentNode.classList.remove('hidden');

        // On marque le lien actuel comme actif
        e.currentTarget.classList.add('active');

        // On affiche les liens du cran du dessous
        let parent = parentNode.parentNode.parentNode;
        const link = parent.querySelector(':scope > .active');
        if (link) {
            // On retire l'ancien lien actif
            link.classList.remove('active');
            link.classList.add('hidden');
        }

        if (parent.classList.contains('hidden')) {
            while (parent.classList.contains('hidden')) {
                // On affiche le parent du dessus
                parent.classList.remove('hidden');

                // On passe au parent du dessus
                parent = parent.parentNode.parentNode;
            }
        }

        const subMenu = parentNode.querySelector('.sub-menu');
        const links = subMenu.querySelectorAll(':scope > .menu-item');
        subMenu.classList.add('not-hidden');
        links.forEach(link => link.classList.remove('hidden'));
    }

    // Masquage/affichage du menu "autre"
    const openedTab = linksContainer.querySelectorAll('.not-hidden');
    if (!otherMenu) return;

    if (!openedTab.length) {
        if (otherMenu.classList.contains('hidden')) otherMenu.classList.remove('hidden');
    } else {
        if (!otherMenu.classList.contains('hidden')) otherMenu.classList.add('hidden');
    }

}

function menuMobile() {
    jQuery(document).ready(function ($) {
        // Hamburger menu
        const body = document.querySelector('body');
        const barsElement = document.querySelector('.bars');
        const mainMenu = document.querySelector('.main-menu');
        const mainPage = document.getElementById('content');

        // Links
        const linksContainer = document.querySelector('.handheld-navigation');

        function resizeMenu() {
            if ($(window).width() < 1200) {
                let menu_height = $(window).height() - $('.main-menu').position().top;
                $('.main-menu').css('height', menu_height + 'px');
            } else {
                $('.main-menu').css('height', 'auto');
            }
        }

        resizeMenu();

        $(window).on('resize', function () {
            resizeMenu();
        });

        if (!linksContainer) return;
        const parentsLinks = linksContainer.querySelectorAll('li.menu-item-has-children');

        barsElement.addEventListener('click', (e) => {
            if ( ! e.isTrusted ) {
                return;
            }

            if (mainMenu.classList.contains('opened')) {
                mainMenu.classList.remove('opened');
                barsElement.classList.remove('opened');
                mainPage.classList.remove('darker');
                body.classList.remove('no-scroll');
            } else {
                mainMenu.classList.add('opened');
                barsElement.classList.add('opened');
                mainPage.classList.add('darker');
                body.classList.add('no-scroll');
                resizeMenu();
            }
        });

        mainPage.addEventListener('click', (e) => {
            if (e.target.classList.contains('darker')) {
                mainMenu.classList.remove('opened');
                barsElement.classList.remove('opened');
                mainPage.classList.remove('darker');
                body.classList.remove('no-scroll');
            }
        });

        $('#menu-menu-principal > li > a').on('click', function(e) {
            let $target = $(e.target);

            if ( $target.attr('href') !== '#' && $target.attr('href').includes('#') ) {
                mainMenu.classList.remove('opened');
                barsElement.classList.remove('opened');
                mainPage.classList.remove('darker');
                body.classList.remove('no-scroll');
            }
        });

        parentsLinks.forEach(parent => {
            const links = parent.querySelectorAll(':scope > a');
            links.forEach(link => {
                link.addEventListener('click', handleClick);
            });
        });
    });
}


export {menuDesktop, menuMobile};
